import React from 'react'
import GradientText from './Animations/GradientText'
import BlurText from './Animations/BlurText'
import AnimatedContent from './Animations/AnimatedContent'
import ShinyText from './Animations/ShinyText'

export default function About() {
    return (
        <div className='px-[5vw] md:mt-[10vw] mt-[15vw] relative'>
            <img src="/images/about.png" alt="" className='md:block hidden w-full' />
            <img src="/images/about-1.png" alt="" className='absolute right-[5vw] -top-10 md:block hidden' />
            <div className='md:absolute static left-[8vw] top-[4vw]'>
                <div className='bg-black md:px-5 py-1 rounded-3xl w-fit md:mb-5 mb-3'>
                    <GradientText
                        colors={["#40ffaa", "#BEFFCD", "#7358F9",]}
                        animationSpeed={3}
                        showBorder={false}
                        className="font-semibold text-lg "
                    >
                        ABOUT DORA
                    </GradientText>
                </div>
                <BlurText
                    text="Key Responsibilities & Importance of DORA"
                    delay={150}
                    animateBy="words"
                    direction="top"
                    className="lg:text-4xl md:text-2xl text-2xl font-bold mb-5"
                />

                <div className='md:w-[700px]'>
                    <AnimatedContent
                        distance={150}
                        direction="horizontal"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <ShinyText text="The key responsibilities include token search, fetching tokens, executing transactions, and completing notifications.
The importance of #AgentDORA ($AD) lies in its specialization as an on-chain agnostic AI agent. It offers a user-friendly experience, efficiency in searching, seamless wallet interaction, quick access to existing tokens, and clear communication. "
                            disabled={false} speed={3} className='custom-class' />
                    </AnimatedContent>
                </div>
                {/* bottom content  */}
                <div className='md:pt-[8vw] pt-20'>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <img src="/images/coins.png" alt="" className='md:w-[17vw] w-full mb-3' />
                    </AnimatedContent>
                    <AnimatedContent
                        distance={150}
                        direction="vertical"
                        reverse={false}
                        config={{ tension: 80, friction: 20 }}
                        initialOpacity={0.2}
                        animateOpacity
                        scale={1.1}
                        threshold={0.2}
                    >
                        <ShinyText text="market reached an all-time high"
                            disabled={false} speed={3} className='custom-class' />
                    </AnimatedContent>
                </div>
            </div>
            <div className='flex items-center md:flex-row flex-col gap-4 md:absolute static bottom-[0vw] right-[6vw] md:mt-0 mt-5'>
                <AnimatedContent
                    distance={150}
                    direction="vertical"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/about-box-1.png" alt="" className='md:w-[28vw] w-full ' />
                </AnimatedContent>
                <AnimatedContent
                    distance={150}
                    direction="vertical"
                    reverse={false}
                    config={{ tension: 80, friction: 20 }}
                    initialOpacity={0.2}
                    animateOpacity
                    scale={1.1}
                    threshold={0.2}
                >
                    <img src="/images/about-box-1.png" alt="" className='md:w-[28vw] w-full ' />
                </AnimatedContent>


            </div>
        </div>
    )
}
